import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'
import { CurrenciesForm } from '@/forms/CurrenciesForm/CurrenciesForm'
import { Collection } from '@/interfaces/Collection'
import { Settings } from '@/interfaces/Settings'
import { Currency } from '@/types/Currency'

export default function SettingsCurrenciesPage() {
  const { data: currencies, isLoading } = useSWR<Collection<Currency>>('/api/v2/currencies', apiFetcher)
  const { data: settings, isLoading: isSettingsLoading } = useSWR<Settings>('/api/v2/settings', apiFetcher)

  return (
    <SettingsPage
      title="Měny"
      description="Hlavní měna se použije pro nové doklady a souhrny. Další měny můžete vybrat při vystavení dokladu."
      breadcrumbHref="/settings/currencies"
    >
      {(isLoading || isSettingsLoading) && <Loading />}

      {currencies && settings && (
        <CurrenciesForm
          currencies={currencies.data}
          defaultValues={{
            primaryCurrency: settings.primaryCurrency!,
            alternativeCurrencies: settings.alternativeCurrencies!,
          }}
        />
      )}
    </SettingsPage>
  )
}
